import { track } from '@eventbrite/datalayer-library';
import { MegaphoneThin } from '@eventbrite/eds-iconography';
import { gettext } from '@eventbrite/i18n';

import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import styles from './SearchResultPanelAdsUpsell.module.scss';

const HEAP_CLICK_ADS_LINK = 'Ads Entry point - Click - Search link';

export type SearchResultsPanelAdsUpsellProps = React.PropsWithoutRef<{}>;

export function SearchResultsPanelAdsUpsell(
    props: SearchResultsPanelAdsUpsellProps,
) {
    const trackUpsellLink = () =>
        track({
            eventName: HEAP_CLICK_ADS_LINK,
            eventData: {
                interface: 'Search - Promoted',
            },
        });

    return (
        <aside className={styles.root} {...props}>
            <section className={styles.callout}>
                <MegaphoneThin className={styles.icon} />
                <div>
                    <Typography
                        className={styles.calloutText}
                        variant="body-md-bold"
                        color="black"
                        as="span"
                    >
                        {gettext('Your event would look great here!')}
                    </Typography>
                    <Typography
                        className={styles.calloutText}
                        variant="body-sm"
                        color="black"
                    >
                        {gettext(
                            'Promote your event with Eventbrite Ads, and we’ll put in front of tons of people searching for experiences like yours.',
                        )}
                    </Typography>
                </div>
            </section>
            <a
                href="/organizations/marketing/eventbrite-ads"
                target="_blank"
                onClick={trackUpsellLink}
                className={styles.link}
            >
                <Button variant="ghost">{gettext('Get started')}</Button>
            </a>
        </aside>
    );
}
